import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { CustomSwitch } from "../custom-switch";
import { useTheme } from "@mui/material";

const UISwitch = ({
  handleChange = () => {},
  label = "",
  labelPlacement = "start",
  checked,
  name,
  size = "medium",
  defaultStyled = true,
  disabled = false,
  sx = {},
  formControlSx = {},
  ...rest
}) => {
  const { palette } = useTheme();
  return (
    <FormControlLabel
      sx={formControlSx}
      name={name}
      control={
        defaultStyled ? (
          <Switch
            sx={{
              // color: palette.custom.primary_button,
              "& .MuiSwitch-track": {
                backgroundColor: `var(--palette-primary_button) !important`,
              },
            }}
            // color={palette.custom.primary_button}
            // color={"var(--palette-custom.primary_button)"}
            size={size}
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            {...rest}
          />
        ) : (
          <CustomSwitch
            size={size}
            checked={checked}
            onChange={handleChange}
            sx={sx}
            disabled={disabled}
            {...rest}
          />
        )
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default UISwitch;
